<template>
  <zoom-center-transition group class="flex flex-wrap">
    <ranch-button
      :label="i18n.buttons.preview"
      icon="eye"
      @click="showImageModal('project-preview')"
      v-if="isRendering"
      key="project_preview"
    ></ranch-button>

    <ranch-button
      :label="i18n.buttons.activity"
      icon="chart-line"
      action="action-secondary"
      @click="showImageModal('project-activity')"
      v-if="isRendering"
      key="project_node_activity"
    ></ranch-button>

    <ranch-button
      :label="i18n.buttons.project_report"
      :icon="['fas', 'clipboard-list']"
      @click="showImageModal('project-report')"
      v-if="isFinished"
      key="project_report"
    ></ranch-button>
    <div
      key="project_warning"
      class="w-full text-sm px-1 whitespace-pre-line"
      v-if="project.qstatus && project.qstatus.explanation"
    >
      {{ project.qstatus.explanation }}
    </div>
  </zoom-center-transition>
</template>

<script>
import ProjectReportModalContent from "./ImageModal/Report";
import ProjectPreviewModalContent from "./ImageModal/Preview";
import ProjectActivityModalContent from "./ImageModal/Activity";

export default {
  props: ["project", "i18n"],
  computed: {
    isRendering() {
      return this.project.status === "inprogress";
    },
    isFinished() {
      return this.project.status === "finished";
    },
  },
  methods: {
    showImageModal(name) {
      const content = {
        "project-activity": ProjectActivityModalContent,
        "project-report": ProjectReportModalContent,
        "project-preview": ProjectPreviewModalContent,
      }[name];

      this.$modal.show(
        content,
        {
          project: this.project,
        },
        {
          name: name,
          adaptive: true,
          reset: true,
          width: "90%",
          height: "auto",
          maxWidth: 1600,
          maxHeight: 900,
          scrollable: true,
          pivotY: 0.1,
          clickToClose: false,
        }
      );
    },
  },
};
</script>
